var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11C7.65625 11 8 11.3438 8 11.75V19.25C8 19.6875 7.65625 20 7.25 20H4.75C4.3125 20 4 19.6875 4 19.25V11.75C4 11.3438 4.3125 11 4.75 11H7.25ZM6 18.75C6.40625 18.75 6.75 18.4375 6.75 18C6.75 17.5938 6.40625 17.25 6 17.25C5.5625 17.25 5.25 17.5938 5.25 18C5.25 18.4375 5.5625 18.75 6 18.75ZM16 6.5625C16 7.875 15.1875 8.625 14.9375 9.5H18.125C19.1562 9.5 19.9688 10.375 19.9688 11.3438C20 11.9062 19.75 12.5 19.375 12.875C19.6875 13.5938 19.625 14.625 19.0938 15.3438C19.3438 16.1562 19.0938 17.1562 18.5625 17.6875C18.7188 18.25 18.6562 18.7188 18.375 19.0938C17.75 20 16.1562 20 14.8125 20H14.7188C13.2188 20 12 19.4688 11 19.0312C10.5 18.8125 9.84375 18.5312 9.34375 18.5312C9.15625 18.5 9 18.3438 9 18.1562V11.4688C9 11.375 9.03125 11.2812 9.09375 11.1875C10.3438 9.96875 10.875 8.6875 11.875 7.65625C12.3438 7.1875 12.5 6.5 12.6875 5.8125C12.8125 5.25 13.0938 4 13.75 4C14.5 4 16 4.25 16 6.5625Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.70e3e9ba.svg";
export { ForwardRef as ReactComponent };